import { NotificationType, UserPreferencesDto, ValidatorResult } from '@onrunning/backstage-models';
import { Account } from '../models/account.model';
import { CrudService } from './crud.service';

export class UsersService {
  private crudService: CrudService<Account>;

  constructor() {
    this.crudService = new CrudService<Account>('users');
  }

  public updatePreferences(userPreferences: UserPreferencesDto): Promise<ValidatorResult<void>> {
    return this.crudService.do('put', 'update-preferences', userPreferences);
  }

  public async updateRelease(externalId: string): Promise<ValidatorResult<void>> {
    return this.crudService.do('put', `update-release?externalId=${externalId}`, undefined, undefined, 'silent');
  }

  public async unsubscribeEmail(token: string, userId: string, notificationType: NotificationType) {
    return this.crudService.do(
      'put',
      'user-notifications/unsubscribe',
      { userId, token, notificationType },
      undefined,
      'silent',
    );
  }

  public updateTutorialGuidanceViewed(guidanceId: string) {
    return this.crudService.do(
      'patch',
      'tutorial-guidance',
      {
        guidanceId,
        viewed: true,
      },
      undefined,
      'silent',
    );
  }
}
